import React, { useEffect } from "react";
import { Outlet, Navigate, useLocation, useNavigate } from "react-router-dom";
import Loader from "../Generic/Loader";
import Page from "../Generic/Page";

const OtherRoute = (props) => {
	const auth = props.login;
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if(auth === false) navigate('/login', { state:{ redirectTo: location.pathname } });; 
	}, [auth])

	if (auth === undefined) {
		return (
			<Page>
				<Loader />
			</Page>
		);
	}

	if (auth) {
		return <Outlet />;
	}
};

export default OtherRoute;
